import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

const StoryBlock = {
	$section: null,

	init: function() {
		this.$section = document.querySelector('.js-story-block');
		if (!this.$section) return;
		this.animate();
	},

	animate: function() {
		const items = this.$section.querySelectorAll('.js-story-block-item');

		gsap.from(items, {
			opacity: 0,
			y: -30,
			duration: 0.8,
			ease: 'power2.out',
			stagger: 0.15,
			scrollTrigger: {
				trigger: this.$section,
				start: 'top 80%',
				once: true,
			},
		});
	},
};

export default StoryBlock;
